<script lang="ts">
	import ThumbnailImage from '$lib/components/ThumbnailImage.svelte';
	import { m } from '$lib/paraglide/messages';

	interface Sibling {
		slug: string;
		image: string;
	}

	let selectedIndex = $state(0);

	let {
		slug,
		showAll = false,
		imageCount = 5,
		siblings,
		selectedImage = $bindable(),
	}: {
		slug: string;
		showAll?: boolean;
		imageCount?: number;
		siblings: Sibling[];
		selectedImage?: string;
	} = $props();
</script>

<!-- eslint-disable custom-rules/no-inline-styles -->
<div
	class="group siblings relative h-full
	xl:h-[calc((100%-(var(--slot-count)-1)*0.25rem)/var(--slot-count))]"
	style="--slot-count:{imageCount};"
>
	<!-- eslint-enable custom-rules/no-inline-styles -->
	<div
		class={[
			'h-full snap-x snap-mandatory gap-1 overflow-x-auto py-1',
			showAll ? 'flex-wrap' : 'xl:grid xl:grid-cols-[repeat(var(--slot-count),1fr)] xl:opacity-0',
			siblings.length > 1 ? 'flex xl:group-hover:opacity-100' : 'hidden',
		]}
		role="group"
		onmouseleave={() => {
			selectedImage = siblings[0].image;
			selectedIndex = 0;
		}}
	>
		{#each siblings as sibling, index (sibling.slug)}
			<a
				href="/{sibling.slug}"
				class={[
					'bg-product aspect-square snap-start rounded border select-none',
					(!showAll && index === selectedIndex) || (showAll && sibling.slug === slug)
						? 'border-black'
						: 'border-transparent',
					index < imageCount - 1 || siblings.length === imageCount || showAll ? '' : 'xl:hidden',
					showAll ? 'h-20' : 'h-full hover:border-black',
				]}
				onfocus={() => {
					if (!showAll) {
						selectedImage = sibling.image;
						selectedIndex = index;
					}
				}}
				onmouseover={() => {
					if (!showAll) {
						selectedImage = sibling.image;
						selectedIndex = index;
					}
				}}
			>
				<ThumbnailImage
					src="product/{sibling.image}"
					loading="lazy"
					maxSize={300}
					alt={sibling.slug}
					class="aspect-square object-cover p-1 mix-blend-darken"
				/>
			</a>
		{:else}
			<div class="aspect-square"></div>
		{/each}
		{#if !showAll && siblings.length > imageCount}
			<div class="group/tooltip bg-product relative hidden h-full rounded xl:block">
				<a
					href="/{slug}"
					class="flex aspect-square items-center justify-center text-center text-lg select-none"
				>
					+{siblings.length - imageCount + 1}
				</a>
			</div>
		{/if}
	</div>
	{#if !showAll}
		<div
			class={[
				siblings.length > 1 ? 'hidden xl:group-hover:hidden' : 'flex',
				'absolute top-0 h-full items-center justify-center text-neutral-400 select-none xl:flex',
			]}
		>
			{m['n_colors']({ count: siblings.length > 1 ? siblings.length : 1 })}
		</div>
	{/if}
</div>
